import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule, Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { PilotPayHttpClient } from './pilotpay-http-client.service';
import { HeaderTitleService } from './headertitle.service';
import { LoaderService } from './loader.service';

/**
 * Parse the URL to the lowercase to manage case sensitivity
 */
@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
	/**
	 *
	 */
	public parse(url: string): UrlTree {
		/**
		 * the auth-callback carries case-sensitive credentials as query params —
		 * the PKCE authorization `code` (a JWT) and the legacy access/refresh
		 * tokens. Lowercasing them corrupts the JWTs (base64url is case-sensitive),
		 * so preserve case for those URLs; only route paths need case-folding.
		 */
		if (/[?&]code=/.test(url) || (url.includes('access_token=') && url.includes('refresh_token='))) {
			return super.parse(url);
		}

		return super.parse(url.toLowerCase());
	}
}

/**
 * core module
 */
@NgModule({
	imports: [
		CommonModule,
		// 3rd party
		NgxPageScrollCoreModule
	],
	exports: [TranslateModule],
	providers: [
		ErrorHandler,
		{ provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
		HeaderTitleService,
		LoaderService,
		PilotPayHttpClient
	]
})
/**
 * CoreModule
 */
export class CoreModule {}
